import { Typography } from '@mui/material';
import { type ResourceIdentifiers } from '@repo/api-gw-sdk';

import { Panels } from '@/components/panels/panels';
import { useWorkspace } from '@/contexts/useWorkspace';
import { PanelSize } from '@/contexts/workspaceContext';

export const ResourceItem = ({
  resource,
  isClickable,
}: {
  resource: ResourceIdentifiers;
  isClickable: boolean;
}) => {
  const { rightPanel } = useWorkspace();
  return isClickable ? (
    <Typography
      className='cursor-pointer underline text-(--mui-palette-text-primary) hover:text-(--mui-palette-text-secondary)'
      onClick={() => {
        rightPanel.setComponent({
          panel: Panels.InventoryInstance,
          props: {
            id: resource.id,
            onClose: () => rightPanel.setIsOpen(false),
            onBack: () => rightPanel.setIsOpen(false),
            initialTab: 'overview',
          },
        });
        rightPanel.setIsOpen(true, PanelSize.Large);
      }}
    >
      {resource.name}
    </Typography>
  ) : (
    <Typography>{resource.name}</Typography>
  );
};
